export function Footer() {
  return (
    <footer className="border-t border-dark-600 bg-dark-900/50 px-6 py-4">
      <div className="flex items-center justify-between text-xs text-gray-500">
        <p>Hirenfire Platform &copy; {new Date().getFullYear()}</p>
        <div className="flex items-center gap-4">
          <a href="#" className="hover:text-gray-300 transition-colors">Terms</a>
          <a href="#" className="hover:text-gray-300 transition-colors">Privacy</a>
          <a href="#" className="hover:text-gray-300 transition-colors">Support</a>
        </div>
      </div>
    </footer>
  );
}
